import { render, staticRenderFns } from "./VLoader.vue?vue&type=template&id=3959edd6&scoped=true&"
import script from "./VLoader.vue?vue&type=script&lang=ts&"
export * from "./VLoader.vue?vue&type=script&lang=ts&"
import style0 from "./VLoader.vue?vue&type=style&index=0&id=3959edd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3959edd6",
  null
  
)

export default component.exports